import ApiConfig from '../utils/ApiConfig';
import axios from 'axios';
import ApiResponse from '../model/response/ApiResponse';
import { ToastContainer, toast } from "react-toastify";
import { useState, useEffect } from "react";
import { Oval } from "react-loader-spinner";
import "../css/Filter.css";



function Report({ show, onClose, userId }) {

    const rawVal = localStorage.getItem('loginVal');
    let loginVal = rawVal ? JSON.parse(rawVal) : null;
    const token = localStorage.getItem('token');

    const [selectedReason, setSelectedReason] = useState("");
    const [isLoading, setIsLoading] = useState(false)
    const [selectedValue, setSelectedValue] = useState();
    const [otherReason, setOtherReason] = useState("");



    function showToast(message) {
        toast.success(message, {
            position: "top-right",
            autoClose: 2000
        });
    }
    function showToastFailed(message) {
        toast.error(message, {
            position: "top-right",
            autoClose: 2000
        });
    }

    useEffect(() => {
        setIsLoading(true);
        if (show && loginVal) {

            getReportAPIcall();
        }
    }, [show]);
    if (!show) return null;



    function getReportAPIcall() {
        setIsLoading(true);

        console.log("Response:", "response.data");
        axios.get(
            ApiConfig.getUrl("User/report_list"),
            {

                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            }
        )
            .then(response => {
                const api = ApiResponse.fromJson(response.data);
                console.log("Response:", api.statusCode);

                if (api.statusCode == 200) {
                    setSelectedReason(api.response);
                    setIsLoading(false);

                }




                // } else {
                //   showToastFailed(api.errorMessage);
                // }

            })
            .catch(error => {
                setIsLoading(false);
                // showToastFailed(error);
                // console.error("Error:", error);
            });
    }

    function reportUserAPICall() {

        setIsLoading(true);
        const reportRequest = {
            user_Id: loginVal.user_Id,
            report_OpponentId: userId,
            report_Reason: parseInt(selectedValue),
            text_Report: otherReason

        };
        axios.post(
            ApiConfig.getUrl("User/user_report"),
            JSON.stringify(reportRequest),
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            }

        )

            .then(response => {
                const api = ApiResponse.fromJson(response.data);
                console.log("Response:", api.statusCode);
                if (api.statusCode == 200) {
                    setIsLoading(false);

                    showToast("Reported Successfully!");

                } else {
                    setIsLoading(false);
                }

            })
            .catch(error => {
                setIsLoading(false);
                showToastFailed("Failed to Report!");
            });
    }

     const disableRightClick = (e) => {
    e.preventDefault();
  };


    return (
        <>
        {isLoading && (
            <div className="loader-overlay">
               <Oval
                  height={60}
                  width={60}
                  color="#ffffff"
                  secondaryColor="#cccccc"
                  strokeWidth={4}
                  visible={true}
               />
            </div>
         )}

            <div  onContextMenu={disableRightClick} className="notif-container mt-5" style={{
                maxHeight: "600px",
                overflowY: "auto",
                overflowX: "hidden",

            }} >

                <div className="notif-header d-flex justify-content-between align-items-center p-2">
                    <div className=" m-0 p-0">
                        <i className="bi bi-arrow-left fs-3"></i>
                    </div>
                    <h5 className="fs-6">Reason for reporting </h5>
                    <button className="btn-close" onClick={onClose}></button>
                </div>
                <hr />


                {(selectedReason && selectedReason.length > 0) ? (
                    selectedReason.map((n) => (
                        <div key={n.reportId} className="p-2 border-bottom">
                            <strong>{n.reportId}</strong> :
                            <label>{n.reports}
                                <input className='ms-2' type='radio'
                                    name={selectedReason}
                                    value={n.reportId}
                                    checked={selectedValue === n.reportId}
                                    onChange={() => {
                                        const value = Number(n.reportId);
                                        setSelectedValue(value);

                                        if (value !== 9) {
                                            setOtherReason("");
                                        }
                                    }} />
                            </label>
                        </div>
                    ))
                ) : (
                    <div className="text-center mt-4">
                        <div style={{ fontSize: "50px" }}>
                            <i className="bi bi-flag me-2"></i>
                        </div>
                        <p className="mt-2 ">
                            You have no Reports so far
                        </p>
                    </div>


                )}
                {selectedValue === 9 && (
                    <div className="mt-2 p-2">
                        <textarea
                            className="form-control"
                            placeholder="Please specify your reason"
                            value={otherReason}
                            onChange={(e) => setOtherReason(e.target.value)}

                        />
                    </div>
                )}


                <div className="p-3" style={{ backgroundColor: "lightblue" }}>
                    <label>Report fraud to our Fraud Prevention Team Immediately.
                        Your information stays confidential
                    </label>
                </div>
                <div className="mb-3 p-1 d-flex mb-4">
                    <button style={{ backgroundColor: "lightgrey" }} 
                     onClick={onClose}>Cancel</button>
                    <button
                        onClick={(e) => {
                            reportUserAPICall();
                            onClose();
                        }}
                        style={{ backgroundColor: "var(--primary-color)" }}>Report</button>
                </div>
            </div>
        </>
    );
}

export default Report;